import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/system";

const FormGrid = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
}));

export default function AddressForm({ address, setAddress }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddress({
      ...address,
      [name]: value,
    });
  };

  return (
    <Grid container spacing={3}>
      <FormGrid item xs={12} md={6}>
        <TextField
          label="First name"
          id="firstName"
          name="firstName"
          value={address.firstName}
          onChange={handleChange}
          placeholder="John"
          autoComplete="given-name"
          required
          fullWidth
        />
      </FormGrid>
      <FormGrid item xs={12} md={6}>
        <TextField
          label="Last name"
          id="lastName"
          name="lastName"
          value={address.lastName}
          onChange={handleChange}
          placeholder="Snow"
          autoComplete="last name"
          required
          fullWidth
        />
      </FormGrid>
      <FormGrid item xs={12}>
        <TextField
          label="Address"
          id="address"
          name="address"
          value={address.address}
          onChange={handleChange}
          placeholder="Street name and number"
          autoComplete="shipping address-line1"
          required
          fullWidth
        />
      </FormGrid>

      <FormGrid item xs={6}>
        <TextField
          label="City"
          id="city"
          name="city"
          value={address.city}
          onChange={handleChange}
          placeholder="New York"
          autoComplete="City"
          required
          fullWidth
        />
      </FormGrid>
      <FormGrid item xs={6}>
        <TextField
          label="State"
          id="state"
          name="state"
          value={address.state}
          onChange={handleChange}
          placeholder="NY"
          autoComplete="State"
          required
          fullWidth
        />
      </FormGrid>
      <FormGrid item xs={6}>
        <TextField
          label="Zip / Postal code"
          id="zip"
          name="zip"
          value={address.zip}
          onChange={handleChange}
          placeholder="12345"
          autoComplete="shipping postal-code"
          required
          fullWidth
        />
      </FormGrid>
      <FormGrid item xs={6}>
        <TextField
          label="Country"
          id="country"
          name="country"
          value={address.country}
          onChange={handleChange}
          placeholder="United States"
          autoComplete="shipping country"
          required
          fullWidth
        />
      </FormGrid>
      <FormGrid item xs={12}>
        <FormControlLabel
          control={<Checkbox name="saveAddress" value="yes" />}
          label="Use this address for payment details"
        />
      </FormGrid>
    </Grid>
  );
}
